import moment from 'moment/moment'

const size = function (size) {
    if(size == undefined) return
    if (size > 1024 * 1024 * 1024 * 1024) {
        return (size / 1024 / 1024 / 1024 / 1024).toFixed(2) + 'T'
    } else if (size > 1024 * 1024 * 1024) {
        return (size / 1024 / 1024 / 1024).toFixed(2) + 'G'
    } else if (size > 1024 * 1024) {
        return (size / 1024 / 1024).toFixed(2) + 'M'
    } else if (size > 1024) {
        return (size / 1024).toFixed(2) + 'K'
    }
    return size.toString() + 'B'
}

const date = function (date, type) {
    if(!isNaN(date) && date.toString().length == 10) {
        date *= 1000
    }
    date = +date ? +date : date
    return moment(date).format(type)
}

const time = function(time) {
    if(time < +new Date) return '已过期'
    let expireTime = time - (+new Date)
    if(expireTime > 24 * 60 * 60 * 1000) {
        var day = expireTime / (24 * 60 * 60 * 1000)
        if((expireTime % (24 * 60 * 60 * 1000)) > (60 * 60 * 1000)) {
            var hour = expireTime % (24 * 60 * 60 * 1000) / (60 * 60 * 1000)
        }
        return `${Math.floor(day)}天/${Math.floor(hour)}小时`
    } else if(expireTime > 60 * 60 * 1000) {
        var hour = expireTime / (60 * 60 * 1000)
        if((expireTime % (60 * 60 * 1000)) > (60 * 1000)) {
            var minute = expireTime % (60 * 60 * 1000) / (60 * 60 * 1000)
        }
        return `${Math.floor(hour)}小时/${Math.floor(minute)}分钟`
    } else  if(expireTime > 60 * 1000) {
        var minute = expireTime / (60 * 1000)
        if((expireTime % (60 * 1000)) > 1000) {
            var second = expireTime % (60 * 1000) / 1000
        }
        return `${Math.floor(minute)}分钟/${Math.floor(second)}秒`
    }
    return `${Math.floor(expireTime / 1000)}秒`
}

const mailDate = function (date) {
    let today = moment(moment().format('YYYY-MM-DD'))
    let yesterday = moment(today).subtract(1, 'days')
    let day = moment(date)
    if (day.diff(today) >= 0) {
        return '今天 ' + day.format('HH:mm')
    } else if (day.diff(yesterday) >= 0) {
        return '昨天 ' + day.format('HH:mm')
    } else {
        return day.format('YYYY-MM-DD HH:mm')
    }
}

const subString = function (str, size) {
    if (!str) {
        return ''
    } else {
        return str.substring(0, size) + (str.length > size ? '...' : '')
    }
}

const prefix = function (str = '', char = '@') {
    return str.split(char)[0]
}

const unescape = function (html) {
    return html.replace(html ? /&(?!#?\w+;)/g : /&/g, '&amp;')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"')
        .replace(/&amp;/g, '&')
}
export {
    size,
    date,
    time,
    prefix,
    mailDate,
    subString,
    unescape
}



// WEBPACK FOOTER //
// ./src/filters/index.js